var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
const Content = styled('span') `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
`;
export const OverflowTooltip = (props) => {
    const { children, tooltipProps } = props, other = __rest(props, ["children", "tooltipProps"]);
    const [isOverflowed, setIsOverflow] = useState(false);
    const textElementRef = useRef(null);
    useEffect(() => {
        if (!textElementRef.current) {
            return;
        }
        setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
    }, []);
    return (_jsx(Tooltip, Object.assign({ title: children, disableHoverListener: !isOverflowed }, tooltipProps, { children: _jsx(Content, Object.assign({ ref: textElementRef }, other, { children: children })) })));
};
